(function(){
  var b=document.getElementById("fsBtn");if(!b)return;
  var de=document.documentElement;
  if(!(document.fullscreenEnabled||document.webkitFullscreenEnabled)||!(de.requestFullscreen||de.webkitRequestFullscreen)){b.remove();return}
  b.addEventListener("click",function(){
    var f=document.getElementById("content");if(!f)return;
    var go=f.requestFullscreen||f.webkitRequestFullscreen;if(!go)return;
    // The page takes the keyboard straight away, so a deck's arrow keys work.
    try{var p=go.call(f);if(p&&p.then)p.then(function(){try{f.contentWindow.focus()}catch(x){}},function(){})}catch(x){}
  });
})();